<template>
  <ContentCard>
    <div class="d-flex flex-column flex-sm-row gap-2">
      <div class="flex-grow-1">
        <h5 class="mb-3">{{ title }}</h5>
        <div class="d-flex flex-column gap-2">
          <slot></slot>
        </div>
      </div>

      <div class="flex-shrink-0 text-end">
        <button type="button"
          class="btn btn-outline-primary"
          :title="'Edit the ' + title"
          @click="$emit('edit')"
        ><span class="bi bi-pencil me-1"></span> Edit</button>
      </div>
    </div>
  </ContentCard>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  }
};
</script>
